<script>
import Range from 'lodash/range'
import DeepClone from 'lodash/cloneDeep'
import _baseDropdownPicker from '../_base-dropdown-picker.vue'
import { getRootTranslator } from '@utils/get-module-translator'

const __rootT = getRootTranslator()
export const taskDependencyStageOptions = () => {
  const stages = []
  Range(1, 16).forEach((r) => {
    stages.push({ text: `${__rootT('stage_count', { count: r })}`, key: r })
  })
  return stages
}

export default {
  name: 'TaskDependencyStagePicker',
  extends: _baseDropdownPicker,
  data() {
    this.unassignedValue = null
    return {}
  },
  computed: {
    options() {
      return DeepClone(taskDependencyStageOptions())
    },
  },
}
</script>
